import * as B from '@blueprintjs/core';
import React from 'react';
import Markdown from 'react-markdown';

import cs from './styles.module.scss';
import {AgentDataConfig} from './types';

export const DataConfigDisplay = ({
  dataConfig,
  runId,
  featureId,
}: {
  dataConfig: AgentDataConfig;
  runId?: string;
  featureId?: number;
}) => {
  return (
    <div className={cs.dataConfigContainer}>
      {runId && (
        <div style={{marginBottom: '1rem'}}>
          <OpenAIRunLogLink runId={runId} featureId={featureId} />
        </div>
      )}
      {Object.entries(dataConfig).map(([key, value]) => (
        <div key={key} style={{marginBottom: '1rem'}}>
          <div className={cs.label}>
            {key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}
          </div>
          <div className={cs.promptMarkdown}>
            {/* An imagery window is a [start, end] pair; everything else is already text. */}
            <Markdown>{Array.isArray(value) ? value.join(' to ') : value?.toString()}</Markdown>
          </div>
        </div>
      ))}
    </div>
  );
};

export const DataConfigDisplayToggle = ({
  showPromptDetails,
  setShowPromptDetails,
}: {
  showPromptDetails: boolean;
  setShowPromptDetails: (show: boolean) => void;
}) => {
  return (
    <B.Tooltip content="Show metadata">
      <B.Button
        icon={showPromptDetails ? 'eye-off' : 'eye-open'}
        onClick={() => setShowPromptDetails(!showPromptDetails)}
        minimal
      />
    </B.Tooltip>
  );
};

export const OpenAIRunLogLink = ({
  runId,
  featureId,
  label,
  buttonProps,
}: {
  runId: string;
  featureId?: number;
  label?: string;
  buttonProps?: Partial<B.AnchorButtonProps>;
}) => {
  return (
    <B.AnchorButton
      target="_blank"
      icon="share"
      minimal
      title="View OpenAI logs"
      outlined
      intent="primary"
      rel="noopener noreferrer"
      href={`https://platform.openai.com/logs?api=responses&metadata[agent_workflow_run_id]=${runId}${featureId ? `&metadata[feature_id]=${featureId}` : ''}`}
      {...buttonProps}
    >
      {label}
    </B.AnchorButton>
  );
};
